import React from "react"

export const context = React.createContext({
  signedIn: false,
})

export const AuthProvider = context.Provider
export const AuthConsumer = context.Consumer
